import { atom } from 'jotai';

import type { StripeSavedCardType } from '../../types';

import type { CreditCardFormValidationErrors } from './creditcardTypes';

// null means user has not interacted with the field yet
// string means user has interacted with the field and there is an error
// empty string means user has interacted with the field and there is no error
export const formValidationErrorsAtom = atom<CreditCardFormValidationErrors>({
  'card-cvc': null,
  'card-expiry': null,
  'card-number': null,
});

export const isSaveCardAtom = atom<boolean>(false);

export const savedCardInfoAtom = atom<StripeSavedCardType | undefined>(
  undefined,
);

export const deleteSavedCardDialogOpenAtom = atom<boolean>(false);

export const isDeleteSaveCardLoadingAtom = atom<boolean>(false);
